import React, { FC } from 'react';
import cn from 'classnames';
import { usePopupContext } from '../../contexts/Settings';
import { isGridLayout } from '../../types';

type ListProps = {
  offerCount: number;
  isProductSelected?: boolean;
};

const UpsellListGrid: FC = ({ children }) => (
  <ul
    className="list-none upsell-list-item-container-grid"
    data-cy-layout="grid"
  >
    {children}
  </ul>
);

const UpsellListTree: FC<ListProps> = ({
  children,
  isProductSelected,
  offerCount,
}) => (
  <ul
    style={
      offerCount < 3
        ? { gridTemplateColumns: `repeat(${offerCount}, 220px)` }
        : {}
    }
    className={cn(
      'Upsell-List list-none',
      !isProductSelected && 'md:ml-50',
      offerCount < 3 && !isProductSelected && 'md:justify-center',
    )}
    data-cy-layout="tree"
  >
    {children}
  </ul>
);

const UpsellList: FC<ListProps> = ({
  children,
  isProductSelected,
  offerCount,
}) => {
  const { settings } = usePopupContext();

  return isGridLayout(settings) ? (
    <UpsellListGrid>{children}</UpsellListGrid>
  ) : (
    <UpsellListTree
      isProductSelected={isProductSelected}
      offerCount={offerCount}
    >
      {children}
    </UpsellListTree>
  );
};

export default UpsellList;
